import { isUngated } from 'collaboration-sidebar/utils/auth';

/**
 * Checks whether we should use FAS commenting to enable the commenting feature.
 * **Must only** be enabled for portals that are already ungated to use the FAS collaboration-sidebar.
 */
export default function useHasFASCommenting() {
  return isUngated('MO:CollaborationSidebar:FASCommenting');
}